import React from "react";

const Label = ({ children, hint, htmlFor }) => (
  <label
    htmlFor={htmlFor}
    className="flex items-baseline gap-2 text-sm font-medium leading-5 text-body"
  >
    {children}
    {hint && <span className="text-xs font-normal text-faint">{hint}</span>}
  </label>
);

export default Label;
